import React from "react";
import PropTypes from "prop-types";
import RecipeList from "./RecipeList";

function HomePage({
  recipes,
  selectRecipe,
  uid,
  apiCalls,
  profile,
  listActions,
  favorites,
}) {
  return (
    <div className="jumbotron">
      <div className="recipes">
        {apiCalls === 0 && !recipes.length ? (
          <div className="jumbotron jumbotron-fluid">
            <div className="d-flex justify-content-center">
              <h3 style={{ paddingTop: "5em" }}>
                {"\u{1F937}\u{200D}\u{2640}\u{FE0F}"} you haven't added any
                recipes yet!
              </h3>
            </div>
            <div className="d-flex justify-content-center">
              {/* <NavLink to={`/cookbook/profile/${user.slug}/recipe/`}>
                Add your first recipe
              </NavLink> */}
            </div>
          </div>
        ) : (
          <RecipeList
            uid={uid}
            recipes={recipes}
            select={selectRecipe}
            favorites={profile.favorites}
            onlyFavorites={favorites}
            toggleFavorite={listActions.toggleFavorite}
          />
        )}
      </div>
    </div>
  );
}

HomePage.propTypes = {
  recipes: PropTypes.array.isRequired,
  selectRecipe: PropTypes.func.isRequired,
  uid: PropTypes.string.isRequired,
  apiCalls: PropTypes.number.isRequired,
  profile: PropTypes.object.isRequired,
  listActions: PropTypes.object,
  favorites: PropTypes.bool,
};

export default HomePage;
